export default __webpack_public_path__ + "static/media/glucerna-2.5021a5ca.jpg";